// Cadence + plain-language helpers

export const CADENCE = {
  never_visited: { label: "Never visited", cls: "bg-[#F3F4F6] text-[#4B5563] border-[#D1D5DB]" },
  due: { label: "Due", cls: "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A]" },
  overdue: { label: "Overdue", cls: "bg-[#FEE2E2] text-[#B91C1C] border-[#FECACA]" },
  going_cold: { label: "Going cold", cls: "bg-[#F3E8FF] text-[#6D28D9] border-[#E9D5FF]" },
  on_track: { label: "On track", cls: "bg-[#D1FAE5] text-[#047857] border-[#A7F3D0]" },
};

export const STATUS_LABELS = {
  not_visited: "Not visited",
  visited: "Visited",
  not_interested: "Not interested",
  group_created: "WhatsApp group created",
};

export const STATUS_STYLE = {
  not_visited: "bg-[#F3F4F6] text-[#4B5563] border-[#D1D5DB]",
  visited: "bg-[#DBEAFE] text-[#1E40AF] border-[#93C5FD]",
  not_interested: "bg-[#FEE2E2] text-[#B91C1C] border-[#FCA5A5]",
  group_created: "bg-[#D1FAE5] text-[#047857] border-[#A7F3D0]",
};

// prospect score tiers (mirrors the scan results page)
export const TIER = {
  hot: { label: "Hot", cls: "bg-[#FEE2E2] text-[#B91C1C] border-[#FCA5A5]" },
  good: { label: "Good", cls: "bg-[#D1FAE5] text-[#047857] border-[#6EE7B7]" },
  maybe: { label: "Maybe", cls: "bg-[#FEF3C7] text-[#B45309] border-[#FCD34D]" },
  skip: { label: "Skip", cls: "bg-[#F3F4F6] text-[#6B7280] border-[#E5E7EB]" },
};

export const BRAND_CLS = {
  German: "bg-[#DBEAFE] text-[#1E40AF]",
  European: "bg-[#E0E7FF] text-[#4338CA]",
  Japanese: "bg-[#FEE2E2] text-[#B91C1C]",
  Korean: "bg-[#FCE7F3] text-[#BE185D]",
  American: "bg-[#FEF3C7] text-[#B45309]",
  general: "bg-[#F3F4F6] text-[#4B5563]",
  unknown: "bg-[#F3F4F6] text-[#9CA3AF]",
};

// pick-list shown when a prospect is marked "Not interested"
export const NOT_INTERESTED_REASONS = [
  { value: "no_german_european", label: "No German or European cars" },
  { value: "buys_from_agency", label: "Buys direct from the agency" },
  { value: "has_supplier", label: "Already has a supplier" },
  { value: "closed_down", label: "Closed down" },
  { value: "other", label: "Other" },
];

export function reasonLabel(value) {
  const r = NOT_INTERESTED_REASONS.find((x) => x.value === value);
  return r ? r.label : value;
}

/** "Wed 19 Aug" — weekday + day + month from a YYYY-MM-DD string (Asia/Dubai) */
export function fmtDay(iso, emptyText = "—") {
  if (!iso) return emptyText;
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", timeZone: "Asia/Dubai" });
}

/** "12 Apr 2026" — date only, no relative suffix (Asia/Dubai) */
export function dateShort(iso, emptyText = "—") {
  if (!iso) return emptyText;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return emptyText;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Dubai" });
}

/** "5:30 pm" in Dubai time */
export function timeOfDay(iso, emptyText = "—") {
  if (!iso) return emptyText;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return emptyText;
  return d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Asia/Dubai" });
}

/** "12 Apr 2026 · 30 days ago" (Asia/Dubai date) */
export function dateWithAgo(iso, emptyText = "—") {
  if (!iso) return emptyText;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return emptyText;
  const date = d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Dubai" });
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  const ago = days <= 0 ? "today" : days === 1 ? "1 day ago" : `${days} days ago`;
  return `${date} · ${ago}`;
}

export function cadenceInfo(flag) {
  return CADENCE[flag] || CADENCE.on_track;
}

export function timeAgo(iso) {
  if (!iso) return "never visited";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "never visited";
  const days = Math.floor((Date.now() - then) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  if (months === 1) return "1 month ago";
  if (months < 12) return `${months} months ago`;
  const years = Math.floor(days / 365);
  return years === 1 ? "1 year ago" : `${years} years ago`;
}

export function money(v) {
  const n = Number(v || 0);
  return `AED ${n.toLocaleString("en-AE", { maximumFractionDigits: 0 })}`;
}

export function purchaseLine(g) {
  const count = g.purchase_count || 0;
  if (!count) return "No orders yet";
  return `${money(g.total_purchase_value)} from ${count} order${count > 1 ? "s" : ""}`;
}
